import { createStore } from "redux";
import rootReducer from "./reducers";
import { composeWithDevTools } from "redux-devtools-extension";
import { ACTION } from "./actionTypes";

const store = createStore(rootReducer, composeWithDevTools());
export const dispatch = (action: ACTION) => store.dispatch(action);

export default store;
